import { VisualizableStrategy } from './visualizableInterface';

export function toVisualization<TModel>(
    strategy: VisualizableStrategy<TModel>,
    model: TModel
) {
    return strategy.toVisualization(model);
}
